import React from "react"
import FaFacebookSquare from "react-icons/lib/fa/facebook-square"
import FaLinkedinSquare from "react-icons/lib/fa/linkedin-square"
import FaInstagram from "react-icons/lib/fa/instagram"
import FaYoutubeSquare from "react-icons/lib/fa/youtube-square"
import FaSoundcloud from "react-icons/lib/fa/soundcloud"
import IconBandcamp from "../atoms/bandcamp-button-circle-whiteblack-32.png"

import typography, { rhythm, scale } from "../utils/typography"
import { metadata, contact } from "../utils/siteSettings.json"
import colors from "../utils/colors"

// Mock Data
if (process.env.NODE_ENV === "development") {
  contact.name = contact.name || "Moa Alphonse Bertelan de la Longue Adresse"
  contact.phone = contact.phone || "0000/000.000"
  contact.email = contact.email || "alphonse.bertelan@ohlalongueadressemail.com"
  contact.facebook = contact.facebook || "monchat"
  contact.linkedin = contact.linkedin || "http://www.linkedin.com/"
  contact.instagram = contact.instagram || "http://www.instagram.com/"
}

let phone = null
let email = null
// prettier-ignore
if (typeof window !== "undefined" && (contact.phone || contact.email)) {
  if (contact.phone) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      phone = <a href={`tel:${contact.phone}`}>{contact.phone}</a>
    }
    else {phone = <span>{contact.phone}</span>}
  }
  if (contact.email)
    email = <a href={`mailto:${contact.email}`} target="_top">{contact.email}</a>
}

class Footer extends React.Component {
  constructor(props) {
    super(props)
    const colorCombo = colors.footerCombo
    const newColors = colors.computeColors([1], colorCombo)
    this.colors = { ...colors, ...newColors }
  }

  render() {
    const {
      classicCombo,
      contrastCombo,
      funkyCombo,
      funkyContrastCombo
    } = this.colors

    return (
      <footer
        className="footer"
        css={{
          ...colors[classicCombo].style,
          ...scale(-0.2),
          lineHeight: 1.3,
          textAlign: `center`,
          width: `100%`,
          padding: `${rhythm(1 / 4)} ${rhythm(1)}`,
          "> p": {
            margin: 0
          },
          " a": {
            fontWeight: `bold`,
            textDecoration: `none`
          },
          " svg, img": {
            ...scale(0.2),
            margin: `0 ${rhythm(1 / 8)}`
          }
          // " img": {
          //   display: `inline`,
          //   height: typography.options.baseFontSize,
          //   width: typography.options.baseFontSize,
          //   verticalAlign: `bottom`,
          //   color: `red`
          // }
        }}
      >
        {/* <p>
          {metadata.name}
        </p> */}
        {typeof contact.callToAction !== `undefined` && (
          <a
            css={{
              display: `block`,
              textTransform: `uppercase`,
              fontWeight: `bold`,
              margin: `0 0 ${rhythm(1 / 4)}`,
              ...this.colors[funkyCombo].style,
              ":hover": {
                ...this.colors[funkyContrastCombo].style
              }
            }}
            href={contact.callToAction.link}
            target="_blank"
            rel="noopener"
          >
            {contact.callToAction.text}
          </a>
        )}
        <p>
          {contact.facebook && (
            <a
              href={`https://www.facebook.com/${contact.facebook}/`}
              target="_blank"
              rel="me noopener"
            >
              <FaFacebookSquare />
            </a>
          )}
          {contact.linkedin && (
            <a href={contact.linkedin} target="_blank" rel="me noopener">
              <FaLinkedinSquare />
            </a>
          )}
          {contact.instagram && (
            <a href={contact.instagram} target="_blank" rel="me noopener">
              <FaInstagram />
            </a>
          )}
          {contact.youtube && (
            <a href={contact.youtube} target="_blank" rel="me noopener">
              <FaYoutubeSquare />
            </a>
          )}
          {contact.soundcloud && (
            <a href={contact.soundcloud} target="_blank" rel="me noopener">
              <FaSoundcloud />
            </a>
          )}
          {/* {contact.bandcamp && (
            <a href={contact.bandcamp} target="_blank" rel="me noopener">
              <img src={IconBandcamp} />
            </a>
          )} */}
        </p>
        {typeof window !== `undefined` && (
          <p
            css={{
              display: `flex`,
              flexFlow: `row wrap`,
              justifyContent: `center`,
              "> *:not(:last-child):after": {
                content: `"-"`,
                margin: `0 3px`,
                fontWeight: `normal`
              }
            }}
          >
            {contact.name && <span>{contact.name}</span>}
            {email}
            {phone}
          </p>
        )}
        <p
          css={{
            // ...scale(-0.3),
            // lineHeight: `none`
            fontSize: rhythm(0.5),
            width: `100%`
            // opacity: 0.8,

            // display: `flex`,
            // flexFlow: `row wrap`,
            // justifyContent: `center`
          }}
        >
          <span>
            <span>Powered by </span>
            <a href="https://www.toile.io/" target="_blank" rel="noopener">
              toile.io
            </a>
          </span>
          <span css={{ margin: `0 3px` }}>-</span>
          <span>
            <span>Designed by </span>
            <a
              href="http://www.feedbydesign.com"
              target="_blank"
              rel="noopener"
            >
              Feed by Design
            </a>
          </span>
        </p>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/molecules/Footer.js